<!--
    COMPONENTE PARA SELECAO DE PARTICIPANTE - SOMENTE CLIENTE POR ENQUANTO
-->

<script>
import Trap from "vue-focus-lock";
import { SysVars } from "../main";
import CustomerForm from "../forms/customer-form";
import CustomerPainelForm from "../forms/customer-painel-form";
import CpfValidate from "../shared/cpf";

export default {
  props: {
    value: {},
    disabled: Boolean,
    addButton: Boolean,
    varejo: Boolean,
    vErrors: {},
    name: { type: String },
    participante: { type: Boolean },
    showMsgEmail: {
      type: Boolean,
      default: true
    },
    seqcontato: { type: [Number, String] }
  },

  data() {
    return {
      textSearch: "",
      inicio: true,
      showList: false,
      notFound: false,
      originalTop: 0,
      myDropDown: "",
      showPartForm: false,
      showPartForcaVendas: false,
      showSituacao: false,

      saldoLimiteCredito: null,

      isChoosing: true,

      selectedIndex: 0,
      selected: {},

      codpart: null,
      crud: "",

      offset: false,

      selectedContato: null
    };
  },

  computed: {
    isForcaVendas: function() {
      return SysVars.appForcaVendas || SysVars.usuarioForcaVendas;
    },

    nextPage: function() {
      return this.$store.getters.getNextPage;
    },

    clienteList: function() {
      return this.$store.getters.getPartList;
    },

    metadata: function() {
      return this.$store.getters.getEntities.metadata;
    },

    emailDanfe: function() {
      if (this.participante && this.showMsgEmail && this.selected.emaildanfe) {
        return (
          "A NF-e autorizada será enviada para " + this.selected.emaildanfe
        );
      } else return null;
    },

    partExists() {
      return !!this.$store.getters.getEntities.part;
    }
  },

  filters: {},

  methods: {
    handleWhatsapp(fone) {
      window.open("https://wa.me/55" + fone + "?text=", "_blank");
    },

    handleEsc() {
      if (!this.showList && this.selected.nome) {
        this.isChoosing = false;
        this.codpart = this.selected.codpart;
        this.$emit("input", this.selected.codpart);
        this.$emit("change", this.selected);
      } else {
        this.showList = false;
        this.notFound = false;
        this.textSearch = "";
        this.$refs.pesquisa.focus();
      }
    },

    closePartForm(id) {
      //ao fechar o formulario de inclusao de clientes
      this.showPartForm = false;
      this.showPartForcaVendas = false;
      if (id) {
        this.loadData(id);
      }
      if (this.isChoosing) {
        this.focus();
      }
    },

    closeSituacaoForm() {
      //ao fechar o formulario de inclusao de clientes
      this.showSituacao = false;
    },

    closeSituacaoForm() {
      //ao fechar o formulario de inclusao de clientes
      this.showSituacao = false;
    },

    handleIncluirCliente() {
      //EXIBE A TELA DE INCLUSAO
      if (this.disabled) {
        return;
      }
      this.crud = SysVars.crudI;
      if (this.isForcaVendas) this.showPartForcaVendas = true;
      else this.showPartForm = true;
    },

    handleAlterarCliente() {
      //EXIBE A TELA DE INCLUSAO
      this.crud = SysVars.crudU;
      this.codpart = this.selected.codpart;
      this.showPartForm = true;
    },

    handleSituacao() {
      this.showSituacao = true;
    },

    handleKeyDown() {
      //TECLA PARA BAIXO
      if (this.clienteList.length > 0) {
        if (this.selectedIndex > this.clienteList.length) {
          this.selectedIndex = 0;
        } else {
          this.selectedIndex = this.selectedIndex + 1;
        }
      }
    },

    handleKeyUp() {
      //TECLA PARA CIMA
      if (this.clienteList.length > 0) {
        if (this.selectedIndex < 1) {
          this.selectedIndex = this.clienteList.length - 1;
        } else {
          this.selectedIndex = this.selectedIndex - 1;
        }
      }
    },

    focus() {
      this.$refs.pesquisa.focus();
    },

    closeForm() {
      this.$emit("closeform");
    },

    handleBlur() {
      if (this.varejo) {
        this.textSearch = this.textSearch.toUpperCase();
        if (CpfValidate(this.textSearch)) {
          // this.$emit('input', this.textSearch)
          this.handleSelect();
        }
      }
      // this.showList = false
    },

    handleChange() {
      // if (!this.textSearch) {
      //     this.showList = false
      //     return
      // }
    },

    handleTrocar() {
      this.isChoosing = true;
      this.textSearch = "";
      this.showList = false;
      this.notFound = false;
      this.codpart = null;
      this.$emit("input", null);
      this.$emit("change", null);
      this.$nextTick(function() {
        this.focus();
      });
    },
    handleNewCostumer() {
      if (this.varejo && this.selected) {
        this.showList = false;
        this.isChoosing = false;
        this.codpart = this.selected.codpart;
        this.$emit("input", this.selected.codpart);
        this.$emit("change", this.selected);
        this.focusControl();
      }
    },
    handleSelect(index) {
      //AO SELECIONAR UM ITEM
      if (index) {
        this.selectedIndex = index;
      }
      if (this.clienteList.length > 0 && this.textSearch) {
        this.selected = this.clienteList[this.selectedIndex];
        this.showList = false;
        this.isChoosing = false;
        this.codpart = this.selected.codpart;
        this.$emit("input", this.selected.codpart);
        this.$emit("change", this.selected);
        this.focusControl();
      } else {
        if (this.varejo && this.textSearch) {
          this.textSearch = this.textSearch.toUpperCase();
          if (CpfValidate(this.textSearch)) {
            let part = { ...this.$store.getters.getEntities.part };
            part.codpart = null;
            part.cnpjcpf = this.textSearch;
            part.nome = "CONSUMIDOR FINAL";
            this.selected = part;
            this.showList = false;
            this.isChoosing = false;
            this.codpart = this.selected.codpart;
            this.$emit("input", this.textSearch);
            this.$emit("change", this.selected);
            this.focusControl();
          } else {
            this.$erpToastError("CPF inválido");
          }
        } else {
          this.$erpToastError("Insira o cliente");
        }
      }
    },

    search() {
      this.inicio = false;

      if (!this.textSearch) {
        this.notFound = false;
        this.showList = false;
        return;
      }

      var term = this.textSearch.toUpperCase();
      // Se o termo parece um CNPJ formatado (contém simbolos e tem tamanho exato de 18 caracteres)
      // removemos a formatação para a pesquisa ser efetiva no banco (alfanumérico puro)
      if (term.length == 18 && (term.indexOf('.') >= 0 || term.indexOf('/') >= 0 || term.indexOf('-') >= 0)) {
        term = term.replace(/[^A-Z0-9]/g, '');
      }

      this.filter =
        '{"nome":{"$or":[{"$like":"%25' +
        term +
        '%25"},{"fantasia":{"$like":"%25' +
        term +
        '%25"}},{"cnpjcpf":{"$eq":"' +
        term +
        '"}},{"codpart":{"$eq":"' +
        term +
        '"}}]}}';

      this.loadData();
    },

    async loadData(id) {
      let params = {
        filter: this.filter,
        id: id,
        forcaVendas: this.isForcaVendas,
        participante: this.participante
      };
      if (this.offset) {
        params.offset = this.nextPage;
        this.offset = false;
      }
      if (id) params.filter = "";
      await this.$store.dispatch("loadCliente", params);
      this.selectedIndex = 0;
      if (id && this.$store.getters.getPart.length > 0) {
        this.selected = this.$store.getters.getPart[0];
        this.isChoosing = false;
        this.calculaLimiteCredito();
      }
      this.loadContato();
    },

    calculaLimiteCredito() {
      // CALCULA O SALDO DE LIMITE DE CREDITO AO SELECIONAR UM CLIENTE
      if (this.selected.limcred && this.selected.limcred > 0) {
        this.saldoLimiteCredito =
          this.$strToFloat(this.selected.limcred, 2) -
          this.$strToFloat(this.selected.saldo_pedidos, 2) -
          this.$strToFloat(this.selected.saldo_titulos_vencer, 2) -
          this.$strToFloat(this.selected.saldo_titulos_vencido, 2);
        //this.saldoLimiteCredito = this.selected.limcred - this.saldo_pedidos - this.saldo_titulos_vencido - this.saldo_titulos_vencer
      } else this.saldoLimiteCredito = null;
    },

    focusControl: function(event) {
      var thisIndex = jQuery(this.$el.querySelector("input")).index(
        SysVars.sFocusControl
      );
      var next = thisIndex + 1;
      var obj = jQuery(SysVars.sFocusControl);
      for (var x = next; x < obj.length; x++) {
        if (
          jQuery(obj[x]).prop("tabindex") === 0 &&
          !jQuery(obj[x]).is("disabled")
        ) {
          jQuery(obj[x]).focus();
          break;
        }
      }
    },

    handleMore() {
      this.offset = true;
      this.loadData();
    },

    async loadContato() {
      this.selectedContato = null;
      if (!this.selected || !this.selected.codpart || !this.seqcontato) return;
      // EXIBE OS DADOS DE UM CONTATO SELECIONADO NO WATCH DO SEQCONTATO
      await this.$store.dispatch("loadPartcontato", {
        codpart: this.selected.codpart,
        id: this.seqcontato
      });
      console.log(this.$store.getters.getPartContato);
      if (this.$store.getters.getPartContato)
        this.selectedContato = this.$store.getters.getPartContato[0];
    }
  },

  watch: {
    seqcontato: function() {
      this.loadContato();
    },

    textSearch: function() {
      let vm = this;
      if (this.keytimer) {
        clearTimeout(this.keytimer);
      }
      this.keytimer = setTimeout(function() {
        console.log("watch textSearch", vm.textSearch);
        vm.search();
      }, 300);
    },

    value: function() {
      if (this.value != this.codpart) {
        this.loadData(this.value);
        this.loadContato();
      }
    },

    clienteList: function() {
      if (this.inicio || !this.textSearch) {
        this.showList = false;
        return;
      }
      if (!this.clienteList.length || this.clienteList.length == 0) {
        this.notFound = true;
        this.showList = false;
      } else {
        this.notFound = false;
        this.showList = true;
      }
    }
  },

  components: {
    Trap,
    CustomerForm,
    CustomerPainelForm
  },

  created() {
    this.$nextTick(function() {
      //const rect = this.$refs.pesquisa.getBoundingClientRect();
      //this.myDropDown = 'top: ' + rect.top + 'px; left: ' + rect.left + 'px;'
      jQuery('[data-toggle="tooltip"]').tooltip();
    });
  },

  mounted() {
    if (this.value) {
      this.loadData(this.value);
    }
    this.originalTop = this.$el.getBoundingClientRect().top;
  }
};
</script>

<template>
  <div class="w-100">
    <div
      class="w-100"
      style="position: relative; z-index: 1; background-color: white"
    >
      <v-label v-if="!addButton || disabled" :label="name"></v-label>
      <v-label v-if="addButton && !disabled" :label="name" title-add-button="Cadastrar" @clickAdd="handleIncluirCliente()"></v-label>

      <!-- DADOS DO CLIENTE SELECIONADO -->
      <div v-show="!isChoosing">
        <div class="row col">
          <span
            class="lbl-title-produto"
            style="cursor: pointer;"
            @click="handleSituacao"
            data-toggle="tooltip"
            data-placement="top"
            title="Ver situação do cliente"
          >
            {{ selected.nome }}
          </span>
          <a
            v-if="selected.codpart && !disabled"
            class="mx-2"
            style="cursor: pointer; color: #0091ea;"
            @click="handleAlterarCliente"
            ><i
              class="fa fa-pencil"
              aria-hidden="true"
              data-toggle="tooltip"
              data-placement="top"
              title="Alterar dados cadastrais"
            ></i
          ></a>
          <a
            v-if="selected.codpart"
            class="mx-2"
            style="width: 25px; height: 25px;cursor: pointer; color: #0091ea; border: 1px solid #0091ea; border-radius: 50px; text-align: center"
            @click="handleSituacao"
            ><i
              class="fa fa-dollar"
              aria-hidden="true"
              data-toggle="tooltip"
              data-placement="top"
              title="Informações do Cliente"
            ></i
          ></a>
          <a
            v-if="!disabled"
            class="mx-2"
            style="cursor: pointer; color: #0091ea;"
            @click="handleTrocar"
            ><i
              class="fa fa-exchange"
              aria-hidden="true"
              data-toggle="tooltip"
              data-placement="top"
              title="Trocar"
            ></i
          ></a>
        </div>
        <div class="row col">
          <span class="data-list mr-2" v-if="selected.cnpjcpf">
            {{ selected.cnpjcpf | formatCNPJCPF }}
          </span>
          <span class="data-list mr-2" v-if="selected.fantasia">
            {{ selected.fantasia }}
          </span>
          <span v-if="selected.nomemun" class="data-list"
            ><i class="fa fa-location-arrow pr-2" aria-hidden="true"></i>
            {{ selected.nomemun }} - {{ selected.uf }}</span
          >
        </div>
        <div class="row col" v-if="emailDanfe">
          <span class="data-list"> {{ emailDanfe }} </span>
        </div>
        <div class="row col">
          <span class="lbl-edit" v-if="saldoLimiteCredito">
            Limite de Crédito Disponível
          </span>
          <span class="data-list" v-if="saldoLimiteCredito">
            {{ saldoLimiteCredito | formatValue(2) }}</span
          >
        </div>
        <div class="row col" v-if="selectedContato">
          <span v-if="selectedContato.nomecontato" class="data-list pr-3"
            ><i class="fa fa-user" aria-hidden="true"></i>
            {{ selectedContato.nomecontato }}</span
          >
          <span v-if="selectedContato.fone1" class="data-list pr-3"
            ><i class="fa fa-phone" aria-hidden="true"></i>
            {{ selectedContato.fone1 | formatFone }}
            <i
              class="fa fa-whatsapp pl-2"
              aria-hidden="true"
              style="color: green; cursor: pointer"
              @click="handleWhatsapp(selectedContato.fone1)"
            ></i>
          </span>
          <span v-if="selectedContato.fone2" class="data-list pr-3"
            ><i class="fa fa-phone" aria-hidden="true"></i>
            {{ selectedContato.fone2 | formatFone }}
            <i
              class="fa fa-whatsapp pl-2"
              aria-hidden="true"
              style="color: green; cursor: pointer"
              @click="handleWhatsapp(selectedContato.fone2)"
            ></i
          ></span>
          <span v-if="selectedContato.fone3" class="data-list pr-3"
            ><i class="fa fa-phone" aria-hidden="true"></i>
            {{ selectedContato.fone3 | formatFone }}
            <i
              class="fa fa-whatsapp pl-2"
              aria-hidden="true"
              style="color: green; cursor: pointer"
              @click="handleWhatsapp(selectedContato.fone3)"
            ></i
          ></span>
          <span v-if="selectedContato.email" class="data-list pr-3"
            ><i class="fa fa-envelope" aria-hidden="true"></i>
            {{ selectedContato.email }}</span
          >
        </div>
        <!-- <div class="row col">
                    <a v-if="!disabled" class="w-100" style="cursor: pointer; color: #0091ea;" @click="handleTrocar"><i class="fa fa-exchange" aria-hidden="true"></i> Trocar <span v-if="name">{{ name }}</span></a>
                    <a style="cursor: pointer; color: #0091ea;" @click="handleAlterarCliente"><i class="fa fa-pencil" aria-hidden="true"></i> Alterar Cadastro</a>
                </div> -->
      </div>

      <!-- SELECIONANDO UM CLIENTE -->
      <div class="row" v-show="isChoosing">
        <div class="col-md-12 col-12">
          <div class="input-group">
            <input
              ref="pesquisa"
              class="form-control form-control-sm"
              autocomplete="off"
              id="search"
              type="text"
              placeholder="Pesquisa o cliente pelo nome, nome fantasia ou CNPJ/CPF"
              v-model="textSearch"
              @blur="handleBlur()"
              @change="handleChange()"
              @keyup.esc="handleEsc()"
              @keydown.enter="handleSelect()"
              @keyup.down="handleKeyDown()"
              @keyup.up="handleKeyUp()"
            />
            <div class="btn-group">
              <a
                href="javascript:void(0);"
                class="btn btn-sm btn-outline-secondary"
                title="Mais Filtros"
                v-if="false"
                @click="search()"
                >...</a
              >
            </div>
            <small
              class="error w-100"
              v-if="name && vErrors && vErrors.has(name)"
              >{{ vErrors.first(name) }}</small
            >
          </div>
          <transition name="fade">
            <div class="col-md-12 col-12">
              <ul
                v-if="notFound && !varejo"
                class="typeahead typeahead-dropdown col"
                style="display: block;"
                :style="myDropDown"
              >
                <li>
                  <div>
                    <span class="typeahead-data"
                      >Nenhum dado foi localizado</span
                    >
                  </div>
                </li>
              </ul>
              <ul
                v-if="showList && clienteList.length > 0"
                class="typeahead typeahead-dropdown col"
                style="display: block;"
                :style="myDropDown"
              >
                <li
                  v-for="(item, index) in clienteList"
                  :class="{ active: index == selectedIndex }"
                  :key="index"
                  @click="handleSelect(index)"
                >
                  <div>
                    <span class="typeahead-title">
                      <small> {{ item.nome }} </small>
                    </span>
                    <span class="typeahead-data"
                      ><small> {{ item.cnpjcpf | formatCNPJCPF }} </small></span
                    >
                    <div class="row">
                      <div class="col-md-6 col-12">
                        <span
                          ><small> {{ item.fantasia }} </small></span
                        >
                      </div>
                      <div class="col-md-6 col-12">
                        <span v-if="item.nomemun"
                          ><small
                            ><i
                              class="fa fa-location-arrow"
                              aria-hidden="true"
                            ></i>
                            {{ item.nomemun }} {{ item.uf }}
                          </small></span
                        >
                      </div>
                      <div class="col-md-6 col-12">
                        <span v-if="item.fone1"
                          ><small
                            ><i class="fa fa-phone" aria-hidden="true"></i>
                            {{ item.fone1 | formatFone }}
                            {{ item.fone2 | formatFone }}
                            {{ item.fone3 | formatFone }}
                          </small></span
                        >
                      </div>
                      <!-- <div class="col-md-6 col-12">
                                                <span v-if="item.email"><small><i class="fa fa-envelope" aria-hidden="true"></i> {{ item.email }} </small></span>
                                            </div> -->
                    </div>
                  </div>
                </li>
                <li v-if="nextPage > 0" @click="handleMore()">
                  <div>
                    <span class="typeahead-title">
                      <small> Exibir Mais </small>
                    </span>
                  </div>
                </li>
              </ul>
            </div>
          </transition>
        </div>
      </div>
    </div>

    <!-- SITUACAO DO CLIENTE -->
    <div class="nb-modal-scrollable" v-if="showSituacao && !varejo">
      <Trap>
        <div class="container nb-modal-scrollable-container">
          <div class="nb-modal-scrollable-body">
            <customer-painel-form
              :modal="true"
              :params="{ codpart: selected.codpart, modal: true }"
              @closeform="closeSituacaoForm"
            ></customer-painel-form>
          </div>
        </div>
      </Trap>
    </div>

    <!-- CADASTRO DE PARTICIPANTE -->
    <div class="nb-modal-scrollable" v-if="showPartForm && !varejo">
      <Trap>
        <div class="container nb-modal-scrollable-container">
          <div class="nb-modal-scrollable-body">
            <customer-form
              :crud="crud"
              :index="codpart"
              @sendData="handleSendData"
              @closeform="closePartForm"
            ></customer-form>
          </div>
        </div>
      </Trap>
    </div>

    <div class="nb-modal-scrollable" v-if="showPartForm && varejo">
      <Trap>
        <div class="container nb-modal-scrollable-container">
          <div class="nb-modal-scrollable-body">
            <customer-form
              :crud="crud"
              :index="codpart"
              @closeform="closePartForm"
              :varejo="true"
            ></customer-form>
          </div>
        </div>
      </Trap>
    </div>

    <div class="nb-modal-scrollable" v-if="showPartForcaVendas">
      <Trap>
        <div
          class="container nb-modal-scrollable-container"
          style="width: 800px; max-width: 100%"
        >
          <div class="nb-modal-scrollable-body">
            <customer-form
              :crud="crud"
              :index="codpart"
              @closeform="closePartForm"
              :forcaVendas="true"
            ></customer-form>
          </div>
        </div>
      </Trap>
    </div>
    <!-- FIM CADASTRO DE PARTICIPANTE -->
  </div>
</template>

<style>
li {
  line-height: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/input-part.vue